var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgISearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1358_22515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8185 23.9992L35.5061 23.9999C37.9914 23.9999 40.0061 26.0146 40.0061 28.4999V30.31C40.0061 32.4974 39.0512 34.5757 37.3916 36.0006C34.2607 38.6885 29.78 40.0022 24 40.0022L23.6419 39.9999C24.2463 38.7829 24.0983 37.2875 23.1989 36.207L22.978 35.9654L18.5182 31.5175C19.4789 29.8633 20 27.9702 20 26C20 25.3167 19.9377 24.648 19.8185 23.9992ZM9 17C13.9706 17 18 21.0295 18 26C18 28.1876 17.2195 30.193 15.9218 31.7527L21.5655 37.3813C22.152 37.9663 22.1531 38.9161 21.568 39.5026C21.0361 40.0357 20.2029 40.0851 19.6151 39.6501L19.4467 39.5051L13.6405 33.713C12.2855 34.53 10.6976 35 9 35C4.02944 35 0 30.9706 0 26C0 21.0295 4.02944 17 9 17ZM9 20C5.68629 20 3 22.6863 3 26C3 29.3137 5.68629 32 9 32C12.3137 32 15 29.3137 15 26C15 22.6863 12.3137 20 9 20ZM24 0.00927734C29.5228 0.00927734 34 4.48643 34 10.0093C34 15.5321 29.5228 20.0093 24 20.0093C18.4772 20.0093 14 15.5321 14 10.0093C14 4.48643 18.4772 0.00927734 24 0.00927734Z",
    fill: "url(#paint0_linear_1358_22515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1358_22515",
    x1: 20.0031,
    y1: 0.00927734,
    x2: 20.0031,
    y2: 40.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B212A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293744"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1358_22515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgISearch);
export default __webpack_public_path__ + "static/media/i-search.d4d77bc9.svg";
export { ForwardRef as ReactComponent };